import {
  ArticleCardContainer,
  ArticleCardLink,
  ArticleCardMeta,
  ArticleCardOverlay,
  ArticleCardTitle,
} from "./styles";
import React from "react";
import PropType from "prop-types";

export default function ArticleCard(props) {
  const article = props.draft ? props.article : props.article.node;

  return (
    <ArticleCardLink href={props.articleLink}>
      <ArticleCardContainer image={article.imageUrl}>
        <ArticleCardOverlay>
          <ArticleCardTitle>{article.title}</ArticleCardTitle>
          <ArticleCardMeta>
            Posted on {article.createdOn} by {article.author.fullName}
          </ArticleCardMeta>
        </ArticleCardOverlay>
      </ArticleCardContainer>
    </ArticleCardLink>
  );
}

ArticleCard.propTypes = {
  articleLink: PropType.string.isRequired,
  article: PropType.object.isRequired,
};
